import snakeCase from 'lodash.snakecase';
import createElement from 'ub/create-dom-element';

const _generateFieldLabel = (field) => {
  const styleSpan = createElement('span', {class: 'label-style'});

  styleSpan.innerHTML = field.validations.required ? `${field.name}&nbsp;*` : field.name;

  const labelElm = createElement('label', {
    class: 'main lp-form-label',
    for: field.id,
    id: `label_${field.id}`
  });

  labelElm.appendChild(styleSpan);

  return labelElm;
};

const _makeFieldViews = (field) => {
  const container = createElement('div', {
    class: `lp-pom-form-field ${field.lpType}`,
    id: `container_${field.id}`
  });

  let label;

  if (!field.hideLabel) {
    label = _generateFieldLabel(field);

    container.appendChild(label);
  }

  const inputWrapper = createElement('div', {class: 'ub-input-item input-wrap'});

  return {
    container,
    inputWrapper,
    label
  };
};

const _addGroupInputs = (groupType, field, inputWrap) => {
  inputWrap.addClassName('optionsList');
  inputWrap.setAttribute('id', `group_${field.id}`);

  field.options.forEach((option, index) => {
    const optionContainer = createElement('div', {
      class: 'option',
      id: `ub-option-${field.id}-item-${index}`
    });

    const valueSnakeCase = snakeCase(option.value);
    const fieldId = `${field.id}_${valueSnakeCase}`;

    const inputElm = createElement('input', {
      type: groupType,
      id: fieldId,
      name: field.id,
      value: option.value,
      class: `${groupType} form-builder-${groupType}-input form_elem_${field.id}`,
      checked: option.checked
    });

    const styleSpan = createElement('span', {class: 'label-style'});

    styleSpan.innerHTML = option.label;

    const labelElm = createElement('label', {
      for: fieldId,
      class: `opt-label form-builder-${groupType}-label`
    });

    labelElm.appendChild(styleSpan);

    optionContainer.appendChild(inputElm);
    optionContainer.appendChild(labelElm);

    inputWrap.appendChild(optionContainer);
  });
};

const getSingleLineTextField = (field) => {
  const views = _makeFieldViews(field);
  const input = createElement('input', {
    id: field.id,
    name: field.id,
    type: 'text',
    placeholder: field.placeholder || '',
    class: `ub-input-item single text form_elem_${field.id}`
  });

  views.container.appendChild(input);

  return {
    field,
    root: views.container,
    label: views.label
  };
};

const getMultiLineTextField = (field) => {
  const views = _makeFieldViews(field);
  const input = createElement('textarea', {
    id: field.id,
    name: field.id,
    class: `ub-input-item single text form_elem_${field.id}`
  });

  views.container.appendChild(input);

  views.container.addClassName('multi-group');

  return {
    field,
    root: views.container,
    label: views.label
  };
};

const getHiddenField = (field) => {
  const input = createElement('input', {
    id: field.id,
    name: field.id,
    type: 'hidden',
    class: 'hidden',
    value: field.value
  });

  return {
    field,
    root: input,
  };
};

const getDropdownField = (field) => {
  const views = _makeFieldViews(field);
  const select = createElement('select', {
    id: field.id,
    name: field.id,
    class: `ub-input-item single form_elem_${field.id}`
  });

  field.selectOptions.each((option, index) => {
    const value = (field.invalidOptions && field.invalidOptions.include(index)) ? '' : option;

    const optionElm = createElement('option', {value: value});
    optionElm.innerHTML = option;

    select.appendChild(optionElm);
  });

  views.container.appendChild(select);

  return {
    field,
    root: views.container,
    label: views.label
  };
};

const getCheckboxField = (field) => {
  const views = _makeFieldViews(field);
  const inputWrap = views.inputWrapper;

  views.container.addClassName('multi-group');

  views.container.appendChild(views.inputWrapper);
  _addGroupInputs('checkbox', field, inputWrap);

  return {
    field,
    root: views.container,
    label: views.label
  };
};

const getRadioField = (field) => {
  const views = _makeFieldViews(field);
  const inputWrap = views.inputWrapper;

  views.container.addClassName('multi-group');

  views.container.appendChild(views.inputWrapper);
  _addGroupInputs('radio', field, inputWrap);

  return {
    field,
    root: views.container,
    label: views.label
  };
};

export default {
  'single-line-text': getSingleLineTextField,
  'email': getSingleLineTextField,
  'multi-line-text': getMultiLineTextField,
  'hidden': getHiddenField,
  'drop-down': getDropdownField,
  'checkbox-group': getCheckboxField,
  'radio-group': getRadioField
};



// WEBPACK FOOTER //
// ./src/elements/form/views.js